export default {
  SET_CURRENT_LANGUAGE(state, data) {
    state.currentLanguage = data;
  },
  SET_LANGUAGE_DATA(state, data) {
    state.language = data;
  },
};
